import React, { useState } from 'react';
import { BASE_URL, Python_BASE_URL } from '../utils/config';
import Loading from './loading';
import { Dialog} from '@mui/material';
import ReactSelect from 'react-select'

const FutureSection = ({ stockSymbols, requestToken, commenteryData, isEditable, onFutureSectionChange, onFutureExpirySelect, onFutureStockSelect, onRemoveFile, onStockLossRecord, generateImage, }) => {

  const [cmperror, setCmpError] = useState(false)
  const [futurecmperror, setFutureCmpError] = useState(false)
  const [slerror, setSlError] = useState(false)
  const [volumeError, setVolumeError] = useState(false)
   const [showAlert, setshowAlert] = useState(false);
    const [AlertMessage, setAlertMessage] = useState("");
  const options = stockSymbols.map((data) => ({
    ...data,
    value: data.name,
    label: data.name,
  }));
  const customStyles = {
    // Define your custom styles here
    menu: (provided) => ({
      ...provided,
      width: '256px',
      marginLeft: '185px',
    }),
    control: (provided, state) => ({
      ...provided,
      width: '256px', // Set the desired width for the entire component
      border: '1px solid #ccc',
      borderRadius: '4px',
      boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : null,
      '&:hover': {
        border: '1px solid #2684FF',
      },
    }),
    // Add more styles for other elements as needed
  };


  const [futureSectionState, setFutureSectionState] = useState({
    futureReportType: 'BUY',
    stockType: '',
    cashCMP: '',
    futureCMP: '',
    futureSL: '0',
    futureRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.',
    commentry: '',
    chartImageInterval:'1D',
    Expiry: '',
    imageData: '',
    base64Data: '',
    volume: '',
    lot_size: '',
    margin: ''
  });
  let RemarkText = 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'
 
  const [expiryData, setExpiryData] = useState([]);
  const [expiryRecord, setExpiryRecord] = useState([]);
  const [expiryshow, setexpiryshow] = useState(false);
  const [showCmpApiError, setShowCmpApiError] = useState(false)
  const [showFutureCmpApiError, setShowFutureCmpApiError] = useState(false)
  const [showFutureSLApiError, setShowFutureSLApiError] = useState(false)
  const [Tradingsymbol,setTradeingSymbol]=useState('');
  const [loading, setLoading] = useState(false);

  // handleInputChange function to handle input changes
  const handleInputChange = (event) => {
    setCmpError(false);
    setFutureCmpError(false);
    setSlError(false);
    const { name, value } = event.target;
    if (/^\d*\.?\d{0,2}$/.test(value)) {
      setFutureSectionState((prevState) => {
        let newState
        if (name === 'futureSL' && value == '0') {

          newState = {
            ...prevState,
            [name]: value,
            futureRemark: RemarkText
          };
        }
        else if (name === 'futureSL' && value != '0') {
          newState = {
            ...prevState,
            [name]: value,
            futureRemark: ""
          };
        }
        else {
          newState = {
            ...prevState,
            [name]: value,
          };
        }

        // Log the updated state
        // console.log("futureSectionState", newState);

        // Notify the parent component about the change
        onFutureSectionChange(newState);

        return newState;
      });
    } else {
      if (name === 'cashCMP') {

        setCmpError(true)
        setTimeout(() => {
          setCmpError(false)
        }, 2000);
      }
      else if (name === 'futureCMP') {
        setFutureCmpError(true)
        setTimeout(() => {
          setFutureCmpError(false)
        }, 2000);
      }
      else if (name === 'futureSL') {
        setSlError(true)
        setTimeout(() => {
          setSlError(false)
        }, 2000);
      }
      else if (name === 'volume') {
        setVolumeError(true)
        setTimeout(() => {
          setVolumeError(false)
        }, 2000);
      }
    }


  };

  // handleChange function to handle changes in radio buttons and select elements liek BUY OR SELL
  const handleChange = (event) => {

    const { name, value } = event.target;

    setFutureSectionState((prevState) => {
      const newState = {
        ...prevState,
        [name]: value,
      };

     
      onFutureSectionChange(newState);

      return newState;
    });



  };

  // handlechangestock function to handle changes in stock selection
  const handlechangestock = async (event) => {
    console.log("event================:", event);
  
    let matchingRecord
    let Expiry_date
    console.log("event", event)

    let tradingsymbol;
    

    setFutureSectionState((prevState) => {
      const newState = {
        ...prevState,
        stockType: event.name,
        cashCMP: '',
        futureCMP: '',
        futureSL: '0',
        futureRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.',
        commentry: '',
        chartImageInterval:'1D',
        Expiry: '',
        imageData: '',
        volume: '',
        margin: ''
      };

      onRemoveFile();
   

      let selectedStockRecord = stockSymbols.find(item => item.name === event.value);
     
      
      onFutureStockSelect(selectedStockRecord);
      switch (selectedStockRecord.name) {
        case "ALUMINI":
          tradingsymbol = 'ALUMINI1!';
          break;
        case "ALUMINIUM":
          tradingsymbol = 'ALUMINIUM1!';
          break;
        case "CRUDEOIL":
          tradingsymbol = 'CRUDEOIL1!';
          break;
        case "CRUDEOILM":
          tradingsymbol = 'CRUDEOILM1!';
          break;
        case "GOLD":
          tradingsymbol = 'GOLD1!';
          break;
        case "GOLDM":
          tradingsymbol = 'GOLDM1!';
          break;
        case "SILVER":
          tradingsymbol = 'SILVER1!';
          break;
        case "SILVERM":
          tradingsymbol = 'SILVERM1!';
          break;
        case "ZINC":
          tradingsymbol = 'ZINC1!';
          break;
        case "ZINCMINI":
          tradingsymbol = 'ZINCMINI1!';
          break;
        case "COPPER":
          tradingsymbol = 'COPPER1!';
          break;
        case "COTTONCNDY":
          tradingsymbol = 'COTTONCNDY1!';
          break;
        case "GOLDGUINEA":
          tradingsymbol = 'GOLDGUINEA1!';
          break;
        case "GOLDPETAL":
          tradingsymbol = 'GOLDPETAL1!';
          break;
        case "KAPAS":
          tradingsymbol = 'KAPAS1!';
          break;
        case "LEAD":
          tradingsymbol = 'LEAD1!';
          break;
        case "LEADMINI":
          tradingsymbol = 'LEADMINI1!';
          break;
        case "MCXBULLDEX":
          tradingsymbol = 'MCXBULLDEX1!';
          break;
        case "MCXMETLDEX":
          tradingsymbol = 'MCXMETLDEX1!';
          break;
        case "MENTHAOIL":
          tradingsymbol = 'MENTHAOIL1!';
          break;
        case "NATGASMINI":
          tradingsymbol = 'NATGASMINI1!';
          break;
        case "NATURALGAS":
          tradingsymbol = 'NATURALGAS1!';
          break;
        case "NICKEL":
          tradingsymbol = 'NICKEL1!';
          break;
        case "SILVERMIC":
          tradingsymbol = 'SILVERMIC1!';
          break;
        case "STEELREBAR":
          tradingsymbol = 'STEELREBAR1!';
          break;
        default:
          // Optionally handle the case where none of the above conditions are met
          tradingsymbol = `${selectedStockRecord.name}1!`; // For example
          break;
      }
    
      onFutureSectionChange(newState);
      return newState;
    });

    

    await fetch(`${BASE_URL}/mxcExpiryData/${event.name}`, {
      method: 'get',
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(res => {
        // Process the API response data
        console.log(res,"repsonse mcx expiry record");

        if (res.success === true) {
          console.log("res", res);
          console.log("res.data", res.data);
          let expiryData = res.data[0].data;
          console.log("expiryData", expiryData);
          Expiry_date = expiryData[0].expiry 
          matchingRecord = expiryData[0];
          setExpiryData(expiryData);
          setExpiryRecord(expiryData[0]);
          setexpiryshow(true);
          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              Expiry: expiryData[0].expiry,
              lot_size: expiryData[0].lot_size,
            };
           
            // console.log("matchingRecord",matchingRecord);
            console.log("result of exp",res.data[0])
            onFutureExpirySelect(expiryData[0]);
            setTradeingSymbol(tradingsymbol);
            generateImage(tradingsymbol, matchingRecord.exchange,futureSectionState.chartImageInterval);
          
            onFutureSectionChange(newState);
            return newState;
          });

        }else{
          setLoading(false)
         setAlertMessage(`Error: ${res.message}`)
         setshowAlert(true)
         setTimeout(() => {
          setshowAlert(false)
          setAlertMessage('')
          }, 2000);
        }
      

      })
      .catch(error => {
        // Handle errors
        setLoading(false)
        console.error('Error fetching data:', error);
        setAlertMessage(`Error: ${error.message}`)
         setshowAlert(true)
         setTimeout(() => {
          setshowAlert(false)
          setAlertMessage('')
          }, 2000);
        
      });


   
    let reportType
    if (futureSectionState.futureReportType === 'Sell') {
      reportType = 'SALE'
    } else {
      reportType = 'BUY'
    }

    if(!Expiry_date || !matchingRecord.tradingsymbol || !matchingRecord.instrument_token){
      setLoading(false)
      setAlertMessage(` Expiry date or trading symbol or instrument token is missing`)  
      setshowAlert(true)
      setTimeout(() => {
        setshowAlert(false)
        setAlertMessage('')
      }, 2000);
      return
    }
    
    console.log("matchingRecord",matchingRecord)
    let body = JSON.stringify({
      report_type: reportType,
      symbol: matchingRecord.tradingsymbol,
      expiry: Expiry_date,
      instrument_token: matchingRecord.instrument_token
    })
    await fetch(`${Python_BASE_URL}/futureStopLossMCX`, {
      method: 'POST',
      body,
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(res => {
        // Process the API response data
        // console.log(res,"repsonse Stop LOss");

        if (res.success === true) {
          console.log("res.data", res);
          let stockrecord
          if (futureSectionState.futureReportType === 'Sell') {
            stockrecord = res.Record.find(item => item.high == res.StopLoss)
            console.log("stockrecord--------------:", stockrecord)
          } else {
            stockrecord = res.Record.find(item => item.low == res.StopLoss)
            console.log("stockrecord--------------:", stockrecord)
          }

          if (!stockrecord) {
            if (futureSectionState.futureReportType === 'Sell') {

              const nearestLowRecord = res.Record.reduce((prev, curr) => {
                const prevDiff = Math.abs(prev.high - res.StopLoss);
                const currDiff = Math.abs(curr.high - res.StopLoss);
                return prevDiff < currDiff ? prev : curr;
              });

              stockrecord = nearestLowRecord;
            } else {
              // Find the nearest high value to res.StopLoss in case of 'PUT'
              const nearestHighRecord = res.Record.reduce((prev, curr) => {
                const prevDiff = Math.abs(prev.low - res.StopLoss);
                const currDiff = Math.abs(curr.low - res.StopLoss);
                return prevDiff < currDiff ? prev : curr;
              });

              stockrecord = nearestHighRecord;
            }
          }
          const roundedStopLoss = parseFloat(res.StopLoss.toFixed(2));
          onStockLossRecord(stockrecord);
          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              futureSL: roundedStopLoss,
              volume: stockrecord.volume,
              futureRemark: ''
            };

            // Log the updated state
            // console.log("futureSectionState", newState);

            // Notify the parent component about the change
            onFutureSectionChange(newState);

            return newState;
          });
          
        }
        else {
          setLoading(false)
          setAlertMessage(`Error: ${res.message}`)
          setShowFutureSLApiError(true)
          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              futureSL: '0',
              volume: '',
              futureRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'
            };

            // Log the updated state
            // console.log("futureSectionState", newState);

            // Notify the parent component about the change
            onFutureSectionChange(newState);

            return newState;
          });
          // setLoading(false)
          setTimeout(() => {
            setShowFutureSLApiError(false)
            setAlertMessage('')
          }, 1500);
        }

      })
      .catch(error => {
        // Handle errors
        setAlertMessage(`Error: ${error.message}`)
        setShowFutureSLApiError(true)
        setFutureSectionState((prevState) => {
          const newState = {
            ...prevState,
            futureSL: "",
            volume: '',
            futureRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'
          };

          // Log the updated state
          // console.log("futureSectionState", newState);

          // Notify the parent component about the change
          onFutureSectionChange(newState);

          return newState;
        });
        setLoading(false)
        setTimeout(() => {
          setShowFutureSLApiError(false)
          setAlertMessage('')
        }, 1500);
        console.error('Error fetching data:', error);
      });

    //  let body = JSON.stringify({request_token:requestToken})
    await fetch(`${BASE_URL}/getkitedata/${matchingRecord.instrument_token}/${requestToken}`, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(res => {
        // Process the API response data
        // console.log(res);

        if (res.success === true) {
          // console.log("res.data",res.instruments);
          let last_price = res.instruments
          last_price = last_price.last_price

          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              futureCMP: last_price,
            };

            // Log the updated state
            // console.log("futureSectionState", newState);

            // Notify the parent component about the change
            onFutureSectionChange(newState);

            return newState;
          });

          // console.log("expiryData", expiryData);
        }
        else {
          setLoading(false)
          setAlertMessage(`Error: ${res.message}`)
          setShowFutureCmpApiError(true)
          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              futureCMP: "",
            };

            // Log the updated state
            // console.log("futureSectionState", newState);

            // Notify the parent component about the change
            onFutureSectionChange(newState);

            return newState;
          });
          setTimeout(() => {
            setShowFutureCmpApiError(false)
            setAlertMessage('')
          }, 1000);
        }

      })
      .catch(error => {
        // Handle errors
        setLoading(false)
        setAlertMessage(`Error: ${error.message}`)
        setShowFutureCmpApiError(true)
        setFutureSectionState((prevState) => {
          const newState = {
            ...prevState,
            futureCMP: "",
          };

          // Log the updated state
          // console.log("futureSectionState", newState);

          // Notify the parent component about the change
          onFutureSectionChange(newState);

          return newState;
        });
        setTimeout(() => {
          setShowFutureCmpApiError(false)
          setAlertMessage('')
        }, 1500);
        console.error('Error fetching data:', error);
      });


      if(!matchingRecord.tradingsymbol || !matchingRecord.instrument_token || !matchingRecord.lot_size){
        setLoading(false)
        setAlertMessage(` Trading symbol or instrument token is missing To calculate margin`)  
        setshowAlert(true)
        setTimeout(() => {
          setshowAlert(false)
          setAlertMessage('')
        }, 2000);
        return
      }
    //calculate margin 
    let Marginbody = JSON.stringify({
      exchange: "MCX",
      tradingsymbol: matchingRecord.tradingsymbol,
      transaction_type: futureSectionState.futureReportType,
      quantity: matchingRecord.lot_size,
    })
    await fetch(`${BASE_URL}/calculateMarginForMCX`, {
      method: 'POST',
      body: Marginbody,
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(res => {
        // Process the API response data
        console.log("margin ===================res ", res);

        if (res.success === true) {
          setLoading(false)
          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              margin: res.orderMargins,
            };
            onFutureSectionChange(newState);
            // setLoading(false)
            return newState;
          });
        } else {
          setLoading(false)
          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              margin: "",
            };
            onFutureSectionChange(newState);
            return newState;
          });
          setAlertMessage(`Error: ${res.message}`)
          setShowCmpApiError(true)
          setTimeout(() => {
            
            setShowCmpApiError(false)
            setAlertMessage('')

          }, 2000);
          // setLoading(false)
        }
      })
      .catch(error => {
        // Handle errors
        // setShowCmpApiError(true)
        setLoading(false)
        setFutureSectionState((prevState) => {
          const newState = {
            ...prevState,
            margin: "",
          };

          // Log the updated state
          // console.log("futureSectionState", newState);

          // Notify the parent component about the change
          onFutureSectionChange(newState);

          return newState;
        });
        setAlertMessage(`Error: ${error.message}`)
        setShowCmpApiError(true)
          setTimeout(() => {
            
            setShowCmpApiError(false)
            setAlertMessage('')

          }, 2000);
        console.error('Error fetching data:', error);
      });
  }

// handleChartinterval function to handle changes in chart interval selection
  const handleChartinterval = (event) => {

    const { name, value } = event.target;

     if (!futureSectionState.stockType || !futureSectionState.Expiry) {
    console.log("Stock symbol not available. Skipping interval change.");
    setAlertMessage(`Please Select Stock Name and Expiry First then try to change the Image Interaval.`);
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 3000);
    return;
  }
    setFutureSectionState((prevState) => {
      const newState = {
        ...prevState,
        [name]: value,
      };

      // Log the updated state
      // console.log("OptionSectionState", newState);

      // Notify the parent component about the change
      onFutureSectionChange(newState);


      generateImage(Tradingsymbol, expiryRecord.exchange,value)
      return newState;
    });


    


  };

  // handleFormatDate function to handle date format
  const formatDate = (dateString) => {

    const dateObject = new Date(dateString);
    const day = dateObject.getDate();
    const month = dateObject.getMonth() + 1; // Months are zero-based
    const year = dateObject.getFullYear();

    // Pad single-digit day and month with a leading zero
    const formattedDate = `${day < 10 ? '0' : ''}${day}-${month < 10 ? '0' : ''}${month}-${year}`;

    return formattedDate;
  }

// handlechangeExpiry function to handle changes in expiry selection
  const handlechangeExpiry = async (event) => {
    console.log("handlechangeExpiry event==============:", event);
    const { name, value } = event.target;
    const selectedExpiryRecord = expiryData.find(item => item.expiry === value);
    console.log("selectedExpiryRecord", selectedExpiryRecord)
    setFutureSectionState((prevState) => {
      const newState = {
        ...prevState,
        [name]: value,
        lot_size: selectedExpiryRecord.lot_size
      };

      // Log the updated state
      // console.log("futureSectionState", newState);

      // Notify the parent component about the change

      onFutureExpirySelect(selectedExpiryRecord);
      onFutureSectionChange(newState);

      return newState;
    });
    setExpiryRecord(selectedExpiryRecord)
    await fetchFutureCMP(value)
  }

  // handleOptionChange function to handle changes in commentary selection
  const handleOptionChange = (event) => {
    const { name, value } = event.target;

    setFutureSectionState((prevState) => {
      const newState = {
        ...prevState,
        [name]: value,
      };

      // Log the updated state
      // console.log("futureSectionState", newState);

      // Notify the parent component about the change
      onFutureSectionChange(newState);
    
      return newState;
    });


  };

  // handleFileChange function to fetch Current CMP
  const fetchCMP = async (event) => {
    // console.log(event)
    event.preventDefault();
    const StockName = futureSectionState.stockType
    console.log("StockName", StockName);
    if(!StockName || !expiryRecord.instrument_token){ 
      setLoading(false)
      setAlertMessage(` Stock name or instrument token is missing to fetch CMP `)  
      setshowAlert(true)
      setTimeout(() => {
        setshowAlert(false)
        setAlertMessage('')
      }, 2000);
      return
    }
    await fetch(`${BASE_URL}/getkitedata/${expiryRecord.instrument_token}/${requestToken}`, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(res => {
        // Process the API response data
        // console.log(res);

        if (res.success === true) {
          // console.log("res.data",res.instruments);
          let last_price = res.instruments
          last_price = last_price.last_price

          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              futureCMP: last_price,
            };

            // Log the updated state
            // console.log("futureSectionState", newState);

            // Notify the parent component about the change
            onFutureSectionChange(newState);

            return newState;
          });

          // console.log("expiryData", expiryData);
        }
        else {
          setLoading(false)
          setAlertMessage(`Error: ${res.message}`)
          setShowFutureCmpApiError(true)
          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              futureCMP: "",
            };

            // Log the updated state
            // console.log("futureSectionState", newState);

            // Notify the parent component about the change
            onFutureSectionChange(newState);

            return newState;
          });
          setTimeout(() => {
            setShowFutureCmpApiError(false)
            setAlertMessage('')
          }, 1000);
        }

      })
      .catch(error => {
        // Handle errors
        setLoading(false)
        setAlertMessage(`Error: ${error.message}`)
        setShowFutureCmpApiError(true)
        setFutureSectionState((prevState) => {
          const newState = {
            ...prevState,
            futureCMP: "",
          };

          // Log the updated state
          // console.log("futureSectionState", newState);

          // Notify the parent component about the change
          onFutureSectionChange(newState);

          return newState;
        });
        setTimeout(() => {
          setShowFutureCmpApiError(false)
          setAlertMessage('')
        }, 1000);
        console.error('Error fetching data:', error);
      });

  }

  // handleFileChange function to handle to fetch future CMP
  const fetchFutureCMP = async (value) => {
   
    const matchingRecord = expiryData.find(item => item.expiry === value);
     
    let reportType
    if (futureSectionState.futureReportType === 'Sell') {
      reportType = 'SALE'
    } else {
      reportType = 'BUY'
    }

    
    console.log("matchingRecord",matchingRecord)
    if(!matchingRecord.tradingsymbol || !matchingRecord.instrument_token){
      setLoading(false)
      setAlertMessage(` Trading symbol or instrument token is missing To fetch future CMP`)  
      setshowAlert(true)
      setTimeout(() => {
        setshowAlert(false)
        setAlertMessage('')
      }, 2000);
      return
    }
    let body = JSON.stringify({
      report_type: reportType,
      symbol: matchingRecord.tradingsymbol,
      expiry: value,
      instrument_token: matchingRecord.instrument_token
    })
    await fetch(`${Python_BASE_URL}/futureStopLossMCX`, {
      method: 'POST',
      body,
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(res => {
        // Process the API response data
        // console.log(res,"repsonse Stop LOss");

        if (res.success === true) {
          console.log("res.data", res);
          let stockrecord
          if (futureSectionState.futureReportType === 'Sell') {
            stockrecord = res.Record.find(item => item.high == res.StopLoss)
            console.log("stockrecord--------------:", stockrecord)
          } else {
            stockrecord = res.Record.find(item => item.low == res.StopLoss)
            console.log("stockrecord--------------:", stockrecord)
          }

          if (!stockrecord) {
            if (futureSectionState.futureReportType === 'Sell') {

              const nearestLowRecord = res.Record.reduce((prev, curr) => {
                const prevDiff = Math.abs(prev.high - res.StopLoss);
                const currDiff = Math.abs(curr.high - res.StopLoss);
                return prevDiff < currDiff ? prev : curr;
              });

              stockrecord = nearestLowRecord;
            } else {
              // Find the nearest high value to res.StopLoss in case of 'PUT'
              const nearestHighRecord = res.Record.reduce((prev, curr) => {
                const prevDiff = Math.abs(prev.low - res.StopLoss);
                const currDiff = Math.abs(curr.low - res.StopLoss);
                return prevDiff < currDiff ? prev : curr;
              });

              stockrecord = nearestHighRecord;
            }
          }
          const roundedStopLoss = parseFloat(res.StopLoss.toFixed(2));
          onStockLossRecord(stockrecord);
          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              futureSL: roundedStopLoss,
              volume: stockrecord.volume,
              futureRemark: ''
            };

            // Log the updated state
            // console.log("futureSectionState", newState);

            // Notify the parent component about the change
            onFutureSectionChange(newState);

            return newState;
          });
          // setLoading(false)
          // console.log("expiryData", expiryData);
        }
        else {
          setLoading(false)
          setAlertMessage(`Error: ${res.message}`)
          setShowFutureSLApiError(true)
          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              futureSL: '0',
              volume: '',
              futureRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'
            };

            // Log the updated state
            // console.log("futureSectionState", newState);

            // Notify the parent component about the change
            onFutureSectionChange(newState);

            return newState;
          });
          // setLoading(false)
          setTimeout(() => {
            setShowFutureSLApiError(false)
            setAlertMessage('')
          }, 1000);
        }

      })
      .catch(error => {
        // Handle errors
        
        setAlertMessage(`Error: ${error.message}`)
        setShowFutureSLApiError(true)
        setFutureSectionState((prevState) => {
          const newState = {
            ...prevState,
            futureSL: "",
            volume: '',
            futureRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'
          };

          // Log the updated state
          // console.log("futureSectionState", newState);

          // Notify the parent component about the change
          onFutureSectionChange(newState);

          return newState;
        });
        setLoading(false)
        setTimeout(() => {
          setShowFutureSLApiError(false)
          setAlertMessage('')
        }, 1000);
        console.error('Error fetching data:', error);
      });

    //  let body = JSON.stringify({request_token:requestToken})
    if( !matchingRecord.instrument_token){
      setLoading(false)
      setAlertMessage(` instrument token is missing to fetch CMP`)  
      setshowAlert(true)
      setTimeout(() => {
        setshowAlert(false)
        setAlertMessage('')
      }, 2000);
      return
    }
    await fetch(`${BASE_URL}/getkitedata/${matchingRecord.instrument_token}/${requestToken}`, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(res => {
        // Process the API response data
        // console.log(res);

        if (res.success === true) {
          // console.log("res.data",res.instruments);
          let last_price = res.instruments
          last_price = last_price.last_price

          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              futureCMP: last_price,
            };

            // Log the updated state
            // console.log("futureSectionState", newState);

            // Notify the parent component about the change
            onFutureSectionChange(newState);

            return newState;
          });

          // console.log("expiryData", expiryData);
        }
        else {
          setLoading(false)
        setAlertMessage(`Error: ${res.message}`)  
          setShowFutureCmpApiError(true)
          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              futureCMP: "",
            };

            // Log the updated state
            // console.log("futureSectionState", newState);

            // Notify the parent component about the change
            onFutureSectionChange(newState);

            return newState;
          });
          setTimeout(() => {
            setShowFutureCmpApiError(false)
            setAlertMessage('')
          }, 1000);
        }

      })
      .catch(error => {
        // Handle errors
        setLoading(false)
        setAlertMessage(`Error: ${error.message}`)
        setShowFutureCmpApiError(true)
        setFutureSectionState((prevState) => {
          const newState = {
            ...prevState,
            futureCMP: "",
          };

          // Log the updated state
          // console.log("futureSectionState", newState);

          // Notify the parent component about the change
          onFutureSectionChange(newState);

          return newState;
        });
        setTimeout(() => {
          setShowFutureCmpApiError(false)
          setAlertMessage('')
        }, 1000);
        console.error('Error fetching data:', error);
      });


      if(!matchingRecord.tradingsymbol || !matchingRecord.instrument_token || !matchingRecord.lot_size){
        setLoading(false)
        setAlertMessage(` Trading symbol or instrument token is missing To calculate margin`)  
        setshowAlert(true)
        setTimeout(() => {
          setshowAlert(false)
          setAlertMessage('')
        }, 2000);
        return
      }
    //calculate margin 
    let Marginbody = JSON.stringify({
      exchange: "MCX",
      tradingsymbol: matchingRecord.tradingsymbol,
      transaction_type: futureSectionState.futureReportType,
      quantity: matchingRecord.lot_size,
    })
    await fetch(`${BASE_URL}/calculateMarginForMCX`, {
      method: 'POST',
      body: Marginbody,
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(res => {
        // Process the API response data
        console.log("margin ===================res ", res);

        if (res.success === true) {
          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              margin: res.orderMargins,
            };
            onFutureSectionChange(newState);
            // setLoading(false)
            return newState;
          });
        } else {

          setLoading(false)
          setFutureSectionState((prevState) => {
            const newState = {
              ...prevState,
              margin: "",
            };
            onFutureSectionChange(newState);
            return newState;
          });
          // setLoading(false)
          setAlertMessage(`Error: ${res.message}`)
          setshowAlert(true)
          setTimeout(() => {
            
            setshowAlert(false)
            setAlertMessage('')

          }, 2000);
        }
      })
      .catch(error => {
        // Handle errors
        // setShowCmpApiError(true)
        setLoading(false)
        setFutureSectionState((prevState) => {
          const newState = {
            ...prevState,
            margin: "",
          };

          // Log the updated state
          // console.log("futureSectionState", newState);

          // Notify the parent component about the change
          onFutureSectionChange(newState);

          return newState;
        });
        setAlertMessage(`Error: ${error.message}`)
          setshowAlert(true)
          setTimeout(() => {
            
            setshowAlert(false)
            setAlertMessage('')

          }, 2000);
        console.error('Error fetching data:', error);
      });
  }

 



  return (
    <div className="futuremain">

      {loading ?
        <div style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 2,
        }}>
          <Loading />
        </div> : null}
      <div id="btnfutureDiv" className="btnfuturediv">
        <p>BUY</p>
        <input type="radio" value="BUY" defaultChecked name="futureReportType" onChange={handleChange} />

        <p>Sell</p>
        <input type="radio" value="Sell" name="futureReportType" onChange={handleChange} />
      </div>

      <div id="future_content" className="futurecontent">

      <div>
          <p>Chart-Image Interval:</p>
          <select value={futureSectionState.chartImageInterval} id="chartImageInterval" name="chartImageInterval" onChange={handleChartinterval}>
  <option value="4h">4h</option>
  <option value="1D">1D</option>
  <option value="1W">1W</option>
  <option value="1M">1M</option>
  <option value="1Y">1Y</option>
</select>
        </div>
        <div>
          <p>Commodity Name:<span className='asterisk'>*</span></p>

        

          <ReactSelect
            id="FutureStocktype"
            name="stockType"
            options={options}
            onChange={handlechangestock}
            styles={customStyles}
            disabled={!isEditable}
          />
        </div>

        {expiryshow ?
          <div style={{ marginTop: '16px' }}>
            <p>Expiry:<span className='asterisk'>*</span></p>
            <select id="Futureexpiry" name="Expiry" value={futureSectionState.Expiry} onChange={handlechangeExpiry} disabled={!isEditable}>
              <option value="">Select Expiry</option>
              {expiryData.map((expiry) => (
                <option key={expiry.instrument_token} value={expiry.expiry}>
                  {formatDate(expiry.expiry)}
                </option>
              ))}
            </select>
          </div>
          : null}
        {cmperror ? <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span> : null}
        {showCmpApiError ? <span style={{ color: 'red', fontSize: '15px' }}>{AlertMessage}</span> : null}




        {futurecmperror ? <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span> : null}
        {showFutureCmpApiError ? <span style={{ color: 'red', fontSize: '15px' }}>{AlertMessage}</span> : null}
        <div>
          <p>Future CMP:<span className='asterisk'>*</span></p>
          <button class="fetch" style={{ cursor: futureSectionState.Expiry == '' ? 'not-allowed' : 'pointer' }} disabled={futureSectionState.Expiry == ''} onClick={fetchCMP}>Fetch</button>
          <input value={futureSectionState.futureCMP} type="number" id="futurecmp" name="futureCMP" onChange={handleInputChange} disabled={!isEditable} />
        </div>



        {slerror ? <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span> : null}
        {showFutureSLApiError ? <span style={{ color: 'red', fontSize: '15px' }}>{AlertMessage}</span> : null}

        <div>
          <p>SL :<span className='asterisk'>*</span></p>
          <input value={futureSectionState.futureSL} type="number" pattern="^[0-9]*$" id="FutureSL" name="futureSL" onChange={handleInputChange} disabled={!isEditable} />
        </div>

        {volumeError ? <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span> : null}

        <div>
          <p>Volume:</p>
          <input value={futureSectionState.volume} type="number" id="volume" name="volume" onChange={handleInputChange} disabled={!isEditable} />
        </div>

        <div>
          <p>Lot Size:</p>

          <input value={futureSectionState.lot_size} type="number" id="lot_size" name="lot_size" readOnly required />


        </div>

       
        <div>
          <p>margin:</p>

          <input value={futureSectionState.margin} type="number" id="margin" name="margin" readOnly required />


        </div>


        <div>
          <p>Select commentary:<span className='asterisk'>*</span></p>
          <select id="selectcommentry" name="commentry" value={futureSectionState.commentry} onChange={handleOptionChange} disabled={!isEditable}>
            <option value="">Select commentary</option>
            {commenteryData.map((data) => (
              <option className='commentery-option' key={data.CommentaryName} value={data.Description}>
                {data.CommentaryName}
              </option>
            ))}
          </select>
         
        </div>


        <div>
          <p>Commentary Remarks:</p>
          <textarea style={{
            border: `2px solid ${futureSectionState.futureSL == '0' ? 'red' : 'rgba(0, 0, 0, 0.2)'}`,
            outline: 'none',
          }} value={futureSectionState.futureRemark} id="futureremark" name="futureRemark" rows={4} onChange={handleChange} disabled={!isEditable} />
        </div>

      </div>

       <Dialog
              open={showAlert}
              onClose={() => { setshowAlert(false) }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <p style={{ color: "green", padding: '10px 30px 10px 30px', margin: 0 }}>{AlertMessage}</p>
            </Dialog>
    </div>
  );
};

export default FutureSection;
